import { getCirugia, postCirugia } from "./ApiHIS"

export const postFormasDeLiquidacionFORLIQ=(body)=>{
    return postCirugia('contratacion/formasliquidacion/buscarformasliquidacion',body)
}

export const postConsultarFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/consultarunaformaliquidar',body)
}

export const postUpdateFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/updateformaliquidar',body)
}

export const postFactorFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/factorformaliquidar',body)
}

export const postListaHonorariosFormaLiquidar=(body)=>{
    return postCirugia('contratacion/formasliquidacion/honorarios',body)
}

export const postCrearFormasDeLiquidar=(body)=>{
    return postCirugia('contratacion/formasliquidacion/crearformasliquidar',body)
}

export const postEliminarFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/eliminarformasliquidar',body)
}

export const postDataCuentasFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/cuentasformasdeliquidacion',body)
}

export const postCrearCuentasFormasDeLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/crearcuentasformasdeliquidacion',body)
}

export const getExcelFormasDeLiquidacion=()=>{
    return getCirugia('contratacion/formasliquidacion/pdfformasdeliquidacion')
}

export const postEliminarCuentasFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/eliminarcuentasformasliquidacion',body)
}

export const postModificarCuentasFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/modificarcuentasformasliquidacion',body)
}

export const postObtenerDataRangoFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/obtenerdatosrangoformasliquidacion',body)
}

export const postInsertarRangosFormasliquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/insertardatosrangoformasliquidacion',body)
}

export const postEliminarRangoFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/eliminardatorangoformasliquidacion',body)
}

export const postActualizarRangoFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/actualizardatorangoformasliquidacion',body)
}

export const postEliminarHonorariosFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/eliminarHonorarioformasliquidacion',body)
}

export const postInsertHonorarioFormasLiquidacion=(body)=>{
    return postCirugia('contratacion/formasliquidacion/insertarHonorarioformasliquidacion',body)
}

//procedimientos individuales
export const postPrincipalProcedimientosIndividuales=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/buscarEnProcedimientosIndividuales',body)
}

export const getObtenerListadosVariosSelectMaestroProcedimiento=()=>{
    return getCirugia('contratacion/procedimientosIndividales/obtenerListadosVariosSelectMaestroProcedimiento')
}

export const postObtenerTipsRIPSMaestroProcedimientos=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerTipsRIPSMaestroProcedimientos',body)
}

export const postObtenerCentrosCostoMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerCentrosCostoMP',body)
}

export const postInsertMaestroProcedimiento=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/insertarMaestroProcedimiento',body)
}

export const postObtenerSiExisteEnMaestroProcedimiento=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerSiExisteEnMaestroProcedimiento',body)
}

export const postObtenerNPCCentrosMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerNPCCentrosMP',body)
}

export const postInsertarNPCCentrosMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/insertarNPCCentrosMP',body)
}

export const postVerificarExistenciaCenCostYCuentasMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/verificarExistenciaCenCostYCuentas',body)
}

export const postActualizarCentrosCostoMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/actualizarCentrosCostoMP',body)
}

export const postEliminarCentroCostoMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/eliminarCentroCostoMP',body)
}

export const postObtenerListaEmpresasMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerListaEmpresasMP',body)
}

export const postObtenerListaSeleccionCuentasVigenciaMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerListaSeleccionCuentasVigenciaMP',body)
}

export const postActualizarMaestroProcedimiento=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/actualizarMaestroProcedimiento',body)
}

// export const postObtenerTipoRIPSMP=(body)=>{
//     return postCirugia('contratacion/procedimientosIndividales/obtenerTipoRIPSMP',body)
// }

export const postObtenerTipoRIPSDeTipoGeneral=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerTipoRIPSDeTipoGeneral', body)
}

export const postObtenerDatosMaestroProcedimientosDos=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerDatosMaestroProcedimientosDos',body)
}

export const postInsertarEnMaestrosProcedimientosDos=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/insertarEnMaestrosProcedimientosDos',body)
}

export const postActualizarMaestrosProcedimientosDos=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/actualizarMaestrosProcedimientosDos', body)
}

export const postObtenerTiposGeneralesMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerTiposGeneralesMP',body)
}

export const postObtenerPerfilesMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerPerfilesMP', body)
}

export const postInsertarPerfilesMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/insertarPerfilesMP', body)
}

export const postObtenerInformacionSedesEmpresaServiciosPrestados=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/obtenerInformacionSedesEmpresaServiciosPrestados', body)
}

export const getObtenerDatosServiciosPrestados=()=>{
    return getCirugia('contratacion/procedimientosIndividales/obtenerDatosServiciosPrestados')
}

export const postInsertarEnServiciosPrestadosIPS=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/insertarEnServiciosPrestadosIPS',body)
}

export const postEliminarServicioPrestado=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/eliminarServicioPrestado',body)
}

export const postverificarYEliminarMaestrosProcdimientos=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/verificarYEliminarMaestrosProcdimientos',body)
}

export const posteliminarPerfilesMP=(body)=>{
    return postCirugia('contratacion/procedimientosIndividales/eliminarPerfilesMP',body)
}

export const postProcedimientosNoOperaciones=(body)=>{
    return postCirugia('contratacion/procedimientos/no/operacionales',body)
}

export const postobtenerImpuestosProcedimientosNoOperecionales=(body)=>{
    return postCirugia('contratacion/procedimientos/obtenerImpuestosProcedimientosNoOperecionales',body)
}

export const postinsertMaestroProcedimientoNoOperacionales=(body)=>{
    return postCirugia('contratacion/procedimientos/insertMaestroProcedimientoNoOperacionales',body)
}

export const postupdateProcedimientoNoOperacionales=(body)=>{
    return postCirugia('contratacion/procedimientos/updateProcedimientoNoOperacionales',body)
}

export const postverificarYEliminarUnProcedimientoNoOperacional=(body)=>{
    return postCirugia('contratacion/procedimientos/verificarYEliminarUnProcedimientoNoOperacional',body)
}